var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-black empty-score-chip",attrs:{"dark":"","small":"","label":""}})}
var staticRenderFns = []

export { render, staticRenderFns }